export default __webpack_public_path__ + "9c37067c520fe33955d0a2d833de590d.png";